import { useState } from "react";
import { seat_value } from "./data";

export default function SeatPlaque(props) {
  // proportions are: 5 x 1
  const { active, height, text, sold } = { ...props };
  const [showPopup, setShowPopup] = useState(false);
  const [hover, setHover] = useState(false);

  console.log(showPopup);
  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (!active) {
      return;
    } else {
      setShowPopup(true);
      console.log(e);
    }
  };
  return (
    <>
      <div
        onClick={(e) => handleClick(e)}
        style={{
          height: height + "px",
          minHeight: height + "px",
          minWidth: 5 * height + "px",
          width: 5 * height + "px",
          fontSize: height / 3.5 + "px",
          boxShadow: "1px 1px 0px 1px #8c7b5b",
          borderRadius: "6px",
          backgroundColor: "#eeca86",
          alignContent: "center",
          textAlign: "center",
          zIndex: showPopup ? 4 : 1,
        }}
      >
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowPopup(false);
          }}
          style={{
            display: showPopup ? "block" : "none",
            border: "2px solid grey",
            backgroundColor: "white",
            padding: "1em",
            transform: "scale(3.0)",
            transformOrigin: "center center",
            height: 1.5 * height,
            width: 5.2 * height,
            maxWidth: 5.2 * height,
            textAlign: "center",
          }}
        >
          <div
            style={{
              textAlign: "right",
              width: "100%",
              marginTop: 0,
              marginBottom: "auto",
            }}
          >
            &times;
          </div>

          <div
            style={{
              minWidth: 5 * height + "px",
              width: 5 * height + "px",
              fontSize: height / 3.5 + "px",
              boxShadow: "1px 1px 0px 1px #8c7b5b",
              borderRadius: "6px",
              backgroundColor: "#eeca86",
              verticalAligh: "middle",
              heihgt: height,

              alignContent: "center",
              textAlign: "center",
            }}
          >
            <div
              style={{
                display: "inline-block",
                marginLeft: 0,
                margintRight: "0",
                width: "0.5em",
                maxWidth: "0.5em",
                alignContent: "center",
                verticalAlign: "middle",
                height: height + "px",
                minHeight: height + "px",
              }}
            >
              &bull;
            </div>
            <div
              style={{
                display: "inline-block",
                margin: "auto",
                width: (height / 2) * 7 + "px",
                alignContent: "center",
                verticalAlign: "middle",
                height: height,
                minHeight: height,
              }}
            >
              {showPopup && !sold ? (
                <span>
                  Your name here!
                  <div
                    onPointerEnter={() => setHover(true)}
                    onPointerLeave={() => setHover(false)}
                    style={{
                      backgroundColor: hover ? "#fce3ab" : "#eeca86",
                      color: "black",
                      border: hover ? "0.33px solid blue" : "0.33px solid grey",
                      fontSize: "5px",
                      paddingTop: "0px",
                      paddingBotom: "2px",
                      overflow: "clip",
                      marginTop: "2px",
                      width: "8em",
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                    onClick={() => {
                      window.parent.location =
                        "https://giving.ucla.edu/Campaign/Donate.aspx?SiteNum=136&amount=" +
                        seat_value;
                    }}
                  >
                    Donate Now&rarr;
                  </div>
                </span>
              ) : (
                text
              )}
            </div>
            <div
              style={{
                display: "inline-block",
                marginRight: 0.0,
                marginLeft: "0",
                width: "0.5em",
                maxWidth: "0.5em",
                alignContent: "center",
                verticalAlign: "middle",
                height: height,
                minHeight: height,
              }}
            >
              &bull;
            </div>
          </div>
          {/* <SeatPlaque active={false} height={2 * height} text={text} />*/}
        </div>
        <div
          style={{
            display: "inline-block",
            marginLeft: 0,
            margintRight: "0",
            width: "0.5em",
            maxWidth: "0.5em",
            height: height,
            minHeight: height,
            alignContent: "center",
            verticalAlign: "middle",
          }}
        >
          &bull;
        </div>
        <div
          style={{
            display: "inline-block",
            margin: "auto",
            width: (height / 2) * 7 + "px",
            alignContent: "center",
            verticalAligh: "middle",
            height: height,
            minHeight: height,
          }}
        >
          {text}
        </div>
        <div
          style={{
            display: "inline-block",
            marginRight: 0.0,
            marginLeft: "0",
            width: "0.5em",
            maxWidth: "0.5em",
            height: height,
            minHeight: height,
            alignContent: "center",
          }}
        >
          &bull;
        </div>
      </div>
    </>
  );
}
